export function buildFormulaMatrix({ formula, coefficients }) {

  switch (formula) {
    case 'bookformula1':
      return [
        [coefficients[0] - 1, -1],
        [-1, coefficients[1] - 1],
      ];
    case 'bookformula2':
      return [
        [coefficients[0] - 1, -1, -1],
        [-1, coefficients[1] - 1, -1],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula3':
      return [
        [coefficients[0] - 1, -1, -1],
        [0, coefficients[1] - 1, -1],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula4':
      return [
        [coefficients[0] - 1, -1, -1],
        [0, coefficients[1] - 1, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula5':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, -1],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula6':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula7':
      return [
        [coefficients[0] - 1, -1, -1],
        [(coefficients[0] - 1) / 2, coefficients[1] - 1, -1],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula8':
      return [
        [coefficients[0] - 1, -1, -1],
        [(coefficients[0] - 1) / 2, coefficients[1] - 1, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula9':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, 0],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula10':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, 0],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula11':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, -0.5],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula12':
      return [
        [coefficients[0] - 1, -1, -1],
        [-0.5, coefficients[1] - 1, -0.5],
        [-1, -1, coefficients[2] - 1],
      ];
    case 'bookformula13':
      return [
        [coefficients[0] - 1, -1, -1],
        [0, (coefficients[1] - 1) / 2, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula14':
      return [
        [coefficients[0] - 1, -1, -1],
        [0, coefficients[1] - 1, -0.5],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula15':
      return [
        [coefficients[0] - 1, -1, -1],
        [(coefficients[0] - 1) / 2, 0, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula16':
      return [
        [coefficients[0] - 1, coefficients[1] - 1, -1],
        [coefficients[0] - 1, -1, coefficients[2] - 1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula17':
      return [
        [coefficients[0] - 1, coefficients[1] - 1, -1],
        [(coefficients[0] - 1) / 2, -1, coefficients[2] - 1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula18':
      return [
        [coefficients[0] - 1, coefficients[1] - 1, -1],
        [(coefficients[0] - 1) / 2, -1, (coefficients[2] - 1) / 2],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula19':
      return [
        [coefficients[0] - 1, coefficients[1] - 1, -1],
        [0, -1, coefficients[2] - 1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula20':
      return [
        [coefficients[0] - 1, coefficients[1] - 1, -1],
        [0, -1, (coefficients[2] - 1) / 2],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'bookformula21':
      return [
        [coefficients[0] - 1, -1, -1],
        [(coefficients[0] - 1) / 2, (coefficients[1] - 1) / 2, -1],
        [-1, coefficients[1] - 1, coefficients[2] - 1],
      ];
    case 'universalFormulaSimple': {
      const length = coefficients.length;
      const result = new Array(length);
      for (let i = 0; i < length; i++) {
        result[i] = new Array(length);
        for (let j = 0; j < length; j++) {
          result[i][j] = i === j ? coefficients[i] - 1 : -1;
        }
      }
      return result;
    }
  }
}
